import React from "react";
import { InputNumber, Button, Space } from "antd";
import type { FilterDropdownProps } from "antd/es/table/interface";

export type MinMaxKey = [number | null, number | null];
export type NumberRangeFilterProps = Omit<
  FilterDropdownProps,
  "selectedKeys" | "setSelectedKeys"
> & {
  selectedKeys: MinMaxKey[];
  setSelectedKeys: (keys: MinMaxKey[]) => void;
};

export const NumberRangeFilter = ({
  setSelectedKeys,
  selectedKeys,
  confirm,
  clearFilters,
}: NumberRangeFilterProps): JSX.Element => {
  const [min, max] = selectedKeys[0] || [];

  return (
    <div style={{ padding: 8 }}>
      <Space direction="vertical">
        <InputNumber
          placeholder="Min"
          value={min}
          onChange={(val): void => setSelectedKeys([[val, max]])}
          style={{ width: "100%" }}
        />
        <InputNumber
          placeholder="Max"
          value={max}
          onChange={(val): void => setSelectedKeys([[min, val]])}
          style={{ width: "100%" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={(): void => confirm()}
            size="small"
            style={{ width: 90 }}
          >
            Filter
          </Button>
          <Button
            onClick={(): void => {
              clearFilters && clearFilters();
              confirm();
            }}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
        </Space>
      </Space>
    </div>
  );
};

// Unknown is safe here
export const renderNumberRangeFilter = (props: unknown): JSX.Element => {
  return <NumberRangeFilter {...(props as NumberRangeFilterProps)} />;
};
